// ============================================================
// Catégories métier d'un thème (liste fixe).
// Dimension indépendante de « type de thème » (table typetheme).
// Elle indique à l'IA ce que la boutique vend réellement, afin
// d'adapter les sections générées (produits / services / mixte).
// ============================================================

export interface ThemeBusinessCategory {
  id: string;
  label: string;
  shortLabel: string;
  icon: string;
  description: string;
  /** Bloc d'instructions injecté dans le prompt envoyé à l'IA. */
  promptBlock: string;
}

export const THEME_BUSINESS_CATEGORIES: ThemeBusinessCategory[] = [
  {
    id: 'products',
    label: 'Vente de produits uniquement',
    shortLabel: 'Produits',
    icon: 'ri-shopping-bag-3-line',
    description: 'Boutique qui vend uniquement des produits physiques ou numériques.',
    promptBlock: `🧭 CATÉGORIE MÉTIER : VENTE DE PRODUITS UNIQUEMENT
- Le site vend exclusivement des PRODUITS. Aucune section « services ».
- Mets en avant {{products}}, {{featured_products}}, {{marketplace_categories}} (si marketplace), le panier et les fiches produit.
- Sections clés : hero catalogue, catégories, produits mis en avant, best-sellers, avis clients, newsletter.
- Ne génère PAS de page « service » ni de bloc {{services}}.`,
  },
  {
    id: 'services',
    label: 'Services uniquement',
    shortLabel: 'Services',
    icon: 'ri-service-line',
    description: 'Activité de prestation : le site vend uniquement des services.',
    promptBlock: `🧭 CATÉGORIE MÉTIER : SERVICES UNIQUEMENT
- Le site vend exclusivement des SERVICES. Aucun catalogue produit.
- Mets en avant {{services}}, le bloc de réservation {{booking_form}}, les témoignages et les études de cas.
- Sections clés : hero présentation, services, processus, équipe, témoignages, prise de rendez-vous.
- Ne génère PAS de page « produits » ni de bloc {{products}}.`,
  },
  {
    id: 'mixed',
    label: 'Mixte — produits et services',
    shortLabel: 'Mixte',
    icon: 'ri-stack-line',
    description: 'Activité qui combine la vente de produits et la prestation de services.',
    promptBlock: `🧭 CATÉGORIE MÉTIER : MIXTE (PRODUITS + SERVICES)
- Le site combine PRODUITS et SERVICES, sur des sections clairement séparées.
- Mets en avant {{products}} ET {{services}}, ainsi que la réservation {{booking_form}}.
- Structure : hero, produits, services, offre combinée, témoignages, contact/réservation.
- Tab de navigation avec deux entrées distinctes : « Boutique » et « Services ».`,
  },
];

export function getBusinessCategory(id?: string | null): ThemeBusinessCategory {
  return THEME_BUSINESS_CATEGORIES.find((c) => c.id === id) || THEME_BUSINESS_CATEGORIES[2];
}

export function getBusinessCategoryLabel(id?: string | null): string {
  return getBusinessCategory(id).shortLabel;
}